var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.078,
    height: 39.492,
    viewBox: "0 0 29.078 39.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4283",
    "data-name": "Group 4283",
    transform: "translate(-139 -1350.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-svgrepo-com",
    transform: "translate(140 1351.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M9.407,6.872A13.345,13.345,0,0,1,19.039,3a13.271,13.271,0,0,1,9.586,3.828,12.445,12.445,0,0,1,3.953,9.285,17.129,17.129,0,0,1-1.408,6.249,38.065,38.065,0,0,1-3.407,6.6q-2,3.08-3.953,5.765T20.493,39l-1.454,1.5q-.545-.616-1.454-1.628t-3.271-4.049a67.749,67.749,0,0,1-4.134-5.9A42.26,42.26,0,0,1,6.954,22.45,17.331,17.331,0,0,1,5.5,16.113,12.374,12.374,0,0,1,9.407,6.872Z",
    transform: "translate(-5.5 -3)",
    fill: "none",
    stroke: "#ee4e56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M19.191,12.6a4.1,4.1,0,1,1-4.1-4.1A4.1,4.1,0,0,1,19.191,12.6Z",
    transform: "translate(-1.556 0.944)",
    fill: "none",
    stroke: "#ee4e56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationRed);
export default __webpack_public_path__ + "static/media/location-red.0f8cfc6e9c164269d2d95e75a42f88ff.svg";
export { ForwardRef as ReactComponent };